export default "__VITE_ASSET__cALcpnAR__"